import { render } from "./ListePromotion.vue?vue&type=template&id=470e5dda&ts=true"
import script from "./ListePromotion.vue?vue&type=script&lang=ts"
export * from "./ListePromotion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__